import styled from 'styled-components';

interface StyledBaseSVGProps {
  width: number;
  strokeColor?: string;
  strokeSize?: number;
}

export const StyledBaseSVG = styled.svg<StyledBaseSVGProps>`
  width: ${({ width }) => width}px;
  display: block;
  ${({ strokeColor }) => (strokeColor !== 'unset' ? `stroke: ${strokeColor};` : '')}
  ${({ strokeSize }) => (strokeSize ? `stroke-width: ${strokeSize}px;` : '')}
`;
